<template>
  <div>
    <tooltip label="View" type="default" placement="right">
      <a class="button is-small" @click="url(this.data)">
        <i class="fa fa-eye"></i>
      </a>
    </tooltip>
    <tooltip label="Move" type="default" placement="right">
      <a class="button is-small" @click="move(this.data)">
        <i class="fa fa-share"></i>
      </a>
    </tooltip>

  </div>
</template>

<script>
  import Tooltip from 'vue-bulma-tooltip'
  import message from '../../../utils/message'
  export default {
    data () {
      return {}
    },
    props: {
      data: {
        type: Object,
        required: true
      }
    },
    components: {
      Tooltip
    },
    methods: {
      url (data) {
        window.open('#/services/service/' + this.data.id)
      },
      view () {
        this.$router.push({name: 'Service', params: {id: this.data.id}})
      },
      move (data) {
        let payment = window.prompt('Payment to move financial')
        if ((payment !== '') && (payment !== null)) {
          if (window.confirm('Are you sure want to move the financial to payment #' + payment)) {
            this.$http.post(this.$store.state.config.apiURL + '/finances/V2/refunds_payment/move_financial', {payment: payment, financial_id: this.data.financial_id}).then((response) => {
              if (response.body === '0') {
                this.message('danger', 'Error', 'A payment #' + payment + ' não existe')
                this.close(true)
              } else if (response.body === '1') {
                this.message('danger', 'Error', 'A payment #' + payment + ' esta protegida ou paga')
                this.close(true)
              } else if (response.body === '2') {
                this.message('danger', 'Error', 'A payment #' + payment + ' não pertence ao mesmo fornecedor')
                this.close(true)
              } else if (response.body === '3') {
                this.message('danger', 'Error', 'A payment #' + payment + ' não pertence a mesma moeda')
                this.close(true)
              } else {
                this.message('success', 'Success', 'The financial was successfully moved to payment #' + payment)
                this.$parent.loadData(true)
              }
            }, (response) => {
              this.message('danger', 'Error', response.body)
            })
          }
        }
      },
      message (type, title, content) {
        let propsData = {
          title: title,
          message: content,
          type: type,
          direction: 'down',
          duration: 4500,
          showCloseButton: true
        }
        message.openMessage(propsData)
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// RefundsPaymentTableButtons.vue?5d555543